import React, { useState } from "react";
import RequestsTable from "./Tables/RequestsTable";
import RequestsModal from "./Modals/RequestsModal";

interface GameInfo {
  id: string;
  [key: string]: any;
}

interface RequestsSectionProps {
  gameInfo: GameInfo;
}

const RequestsSection: React.FC<RequestsSectionProps> = ({ gameInfo }) => {
  const [modalDets, setModalDets] = useState({
    open: false,
    status: "",
    reqData: {},
  });

  return (
    <div>
      <h2>Requests</h2>
      <RequestsModal dets={modalDets} gameInfo={gameInfo} />
      <RequestsTable setModalDets={setModalDets} gameInfo={gameInfo} />
    </div>
  );
};

export default RequestsSection;
